<div class="card">

	<div style="width: 200px; height: 200px" class="card-body" >
        <ng-container *ngIf="itemSubject.asObservable() | async as z">
        <ng-container *ngIf="z.content && z.file.type.includes('image')">
        <img class="fit-parent" src="{{z.content}}" title={{z.file.name}} />
    </ng-container>
        <ng-container *ngIf="z.content && !(z.file.type.includes('image'))">
            <div class="card-title">{{z.file.name}}</div>
            <div class="card-title">File type: {{z.file.type}}</div>
        </ng-container>

        <button type="button" style="transform: scale(0.4);"class="btn-close close-button" (click)="clickedDeleteButton(z)">
            <span class="icon-cross" ></span>
          </button>

</ng-container>
    </div>
</div>
